<form (ngSubmit)="submitForm()" [formGroup]="this.formGroup">

   <!-- If the backend passed through a HostedForm property and its Property is FluidPay, then render app-fluidpay-tokenizer -->
   <!-- If any other 3rd party forms are needed we can add them here if we want their form to be rendered above ours -->
   <app-fluidpay-tokenizer 
      *ngIf="form.HostedForm?.Provider === 'Fluidpay'"
      [hostedForm]="form.HostedForm">
   </app-fluidpay-tokenizer>

   <!-- has-page-text class is added if the form has a page-text field -->
   <div class="form-container" [class.has-page-text]="this.formHasPageTextField">
      <ng-container *ngFor="let field of this.form.fields | keyvalue: asIsOrder">

         <!-- 
            The following conditional will only display the fields if the value in the FieldVisibility object is true.
            The logic for setting up and asynchronously editing the FieldVisibility is in the form.component.ts file.
         -->
         <ng-container *ngIf="FieldVisibility[field.key]">
            <div class="grid-form-field">
               <div app-easysuite-radio *ngIf="field.value.type === 'radio'" 
               [field]="field.value" [fieldKey]="field.key"
               [formGroup]="this.formGroup"></div>
               
               <div app-easysuite-timepicker *ngIf="field.value.type === 'time picker'" 
               [field]="field.value" [fieldKey]="field.key" 
               [formGroup]="this.formGroup"></div>
               
               <div app-easysuite-datepicker *ngIf="field.value.type === 'date picker'" 
               [field]="field.value" [fieldKey]="field.key" 
               [formGroup]="this.formGroup"></div>
               
               <!-- Text, number, price fields -->
               <div app-easysuite-textfield *ngIf="field.value.type === 'text' || field.value.type === 'text dollars'"
               [field]="field.value" [fieldKey]="field.key" 
               [formGroup]="this.formGroup"></div>
               
               <div app-easysuite-multilevel-checkbox *ngIf="field.value.type === 'multilevel-checkbox'" 
               [field]="field.value" [fieldKey]="field.key" 
               [formGroup]="this.formGroup"></div>
               
               <div app-easysuite-multi-checkbox *ngIf="field.value.type === 'multi-checkbox'" 
               [field]="field.value" [fieldKey]="field.key" 
               [formGroup]="this.formGroup"></div>
               
               <div app-easysuite-textarea *ngIf="field.value.type === 'textarea'" 
               [field]="field.value" [fieldKey]="field.key" 
               [formGroup]="this.formGroup"></div>
               
               <div app-easysuite-dropdown *ngIf="field.value.type === 'dropdown'" 
               [field]="field.value" [fieldKey]="field.key" 
               [formGroup]="this.formGroup"></div>
               
               <div app-easysuite-checkbox *ngIf="field.value.type === 'checkbox'" 
               [field]="field.value" [fieldKey]="field.key" 
               [formGroup]="this.formGroup"></div>
               
               <div app-easysuite-upload *ngIf="field.value.type === 'file'" 
               [field]="field.value" [fieldKey]="field.key" 
               [formGroup]="this.formGroup"></div>
               
               <div app-easysuite-password *ngIf="field.value.type === 'password'" 
               [field]="field.value" [fieldKey]="field.key" 
               [formGroup]="this.formGroup"></div>
               
               <div app-easysuite-page-text *ngIf="field.value.type === 'Page Text'" 
               [field]="field.value"></div> 

            </div>
         </ng-container>
      </ng-container>
   </div>

   <div class="form-actions">
      <button *ngIf="this.form.showSubmitButton" id="btn_submit" type="submit" 
         class="btn btn-success">Submit</button>
      <input *ngIf="this.form.showCancelButton" id="btn_cancel" type="button" 
         (click)="cancelForm()" class="btn btn-success" value="Cancel">
      <button *ngFor="let button of buttons" class="btn btn-success extra_button_form"
         (click)="additionalFormButtonClick(button)"> {{button.Label}} </button>
   </div>
</form>